import BaseResponse from "../../../infrastructure/model/base/BaseResponse";
import { CreateRawMaterialRequest, RawMaterialModel } from "../../../infrastructure/model/RawMaterialModel";
import RawMaterialService from "../../../infrastructure/services/RawMaterialService";
import HttpUtils from "../../utils/HttpUtils";
import { BaseCommonApiUseCaseDeps } from "./CommonApiUseCase";


interface DeleteUOMUseCaseDeps extends BaseCommonApiUseCaseDeps {
  id: number;
}

export const getListRawMaterialUseCase = async (deps: BaseCommonApiUseCaseDeps): Promise<RawMaterialModel[]> => {
  const { setLoading, showError } = deps;
  try {
    setLoading?.(true);
    let dataMapper: RawMaterialModel[] = [];
    const res = await RawMaterialService.getListRawMaterial();
    HttpUtils.handleResponse(res, {
      onDefaultError() {
        showError?.(res.message);
      },
      onSuccessWithData(res) {
        dataMapper = res.data;
      },
    });
    return dataMapper;
  } finally {
    setLoading?.(false);
  }
};

export const insertRawMaterialUseCase = async (
  deps: BaseCommonApiUseCaseDeps & {
    id?: number;
    request: CreateRawMaterialRequest
  }
): Promise<RawMaterialModel | undefined> => {
  const { id, request, setLoading, showError, showSuccess } = deps;
  try {
    setLoading?.(true);
    let dataMapper: RawMaterialModel | undefined = undefined;
    let res: BaseResponse<RawMaterialModel> = {} as BaseResponse<RawMaterialModel>;
    if (id && id > 0) {
      res = await RawMaterialService.updateRawMaterial(id, request);
    } else {
      res = await RawMaterialService.createRawMaterial(request);
    }
    HttpUtils.handleResponse(res, {
      onDefaultError() {
        showError?.(res.message);
      },
      onSuccessWithData(res) {
        showSuccess?.();
        dataMapper = res.data;
      },
    });
    return dataMapper;
  } finally {
    setLoading?.(false);
  }
};

export const deleteRawMaterialUseCase = async (deps: DeleteUOMUseCaseDeps): Promise<boolean> => {
  const { id, setLoading, showError, showSuccess } = deps;
  try {
    setLoading?.(true);
    let dataMapper = false;
    const res = await RawMaterialService.deleteRawMaterial(id);

    HttpUtils.handleResponse(res, {
      onDefaultError() {
        showError?.(res.message);
      },
      onSuccess() {
        showSuccess?.();
        dataMapper = true
      },
    });
    return dataMapper;
  } finally {
    setLoading?.(false);
  }
};